import "reflect-metadata"
import Vue from 'vue'
import Buefy from 'buefy'
import App from './App.vue'
import router from './router'
import Toasted from 'vue-toasted';
import VueObserveVisibility from 'vue-observe-visibility'

import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

import { VuePinch } from '@/artdirector/directives/pinch';

require('@/assets/main.scss')

Vue.use(Toasted)
Vue.use(VuePinch)

// @ts-ignore
library.add(fas);
Vue.component('vue-fontawesome', FontAwesomeIcon);

Vue.use(Buefy, {
  defaultIconComponent: "vue-fontawesome",
  defaultIconPack: "fas",
  customIconPacks: {
    fas: {
      sizes: {
        default: "lg",
        "is-small": "1x",
        "is-medium": "2x",
        "is-large": "3x"
      },
      iconPrefix: ""
    }
  }
});


Vue.use(VueObserveVisibility)


Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
